import graph from "@irati/utils/services/graph";
var getCompanyValues = function (variables) {
    var query = "\n    query CompanyValues($limit: Int, $tenantId: String!) {\n      companyValues(limit: $limit, tenantId: $tenantId) {\n        results {\n          icon {\n            href\n            alt\n          }\n          name\n          uuid\n          tag\n        }\n      }\n    }\n  ";
    return graph({ query: query, variables: variables }).then(function (data) {
        return Promise.resolve(data.companyValues);
    });
};
export default getCompanyValues;
